"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateTextNote = exports.truncateText = void 0;
const truncateText = (text, length = 20) => {
    const words = text.split(/\s+/g);
    return (words.slice(0, length).join(" ") + (words.length > length ? "..." : ""));
};
exports.truncateText = truncateText;
const truncateTextNote = (text, length = 15) => {
    const words = text.split(/\s+/g);
    return (words.slice(0, length).join(" ") + (words.length > length ? " ...more" : ""));
};
exports.truncateTextNote = truncateTextNote;
//# sourceMappingURL=truncateText.js.map